import { render, staticRenderFns } from "./UploadManager.vue?vue&type=template&id=4861a4e6&"
import script from "./UploadManager.vue?vue&type=script&lang=ts&"
export * from "./UploadManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports